import { render } from "./MaterialAddEditFormModal.vue?vue&type=template&id=aac720f8&lang=pug"
import script from "./MaterialAddEditFormModal.vue?vue&type=script&lang=ts"
export * from "./MaterialAddEditFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script